<template>
  <VWidget :title="$t('Details')">
    <div slot="widget-content">
      <!-- Title -->
      <h5>{{ $t('Name') }}</h5>
      <translatable
        :language="language"
        v-model="product"
        field-name="name"
      >
        <template
          #default="{ fieldValue, fieldMutator }"
        >
          <v-text-field
            v-model="fieldValue"
            :label="$t('Insert title...')"
            :error-messages="verrors('name')"
            outline
            @change="fieldMutator(fieldValue)"
          />
        </template>
      </translatable>

      <v-layout row>
        <v-flex xs12>
          <v-text-field
            v-model="product.slug"
            :error-messages="verrors('slug')"
            :label="$t('Slug')"
            :disabled="language && !language.default"
            outline
          />
        </v-flex>
        <v-flex
          v-if="language && language.default"
        >
          <v-btn
            block
            large
            @click="generateSlug">
            {{ $t('Generate') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- Description -->
      <h5>{{ $t('Description') }}</h5>
      <translatable
        :language="language"
        v-model="product"
        field-name="description"
      >
        <template
          #default="{ fieldValue, fieldMutator }"
        >
          <quill-editor
            ref="myQuillEditor"
            v-model="fieldValue"
            :options="editorOption"
            @change="({html}) => fieldMutator(html)"
          />
        </template>
      </translatable>

      <translatable
        :language="language"
        v-model="product"
        field-name="tags"
        class="mt-3"
      >
        <template
          #default="{ fieldValue, fieldMutator, dynamicFieldValue }"
        >
          <v-layout
            wrap
            row
          >
            <v-flex xs12>
              <h5>{{ $t('Tags') }}</h5>

              <v-combobox
                v-model="fieldValue"
                :filter="filterTag"
                :items="dynamicFieldValue || []"
                :label="$t('Type to create')"
                append-icon
                multiple
                small-chips
                outline
                hide-details
                deletable-chips
                @change="fieldMutator(fieldValue)"
              />
            </v-flex>
          </v-layout>
        </template>
      </translatable>
    </div>
  </VWidget>
</template>

<script>

import Translatable from '@/components/widgets/Translatable'
export default {
  name: 'ProductSingleDescription',
  components: { Translatable },
  props: {
    product: {
      type: Object,
      required: true
    },
    language: {
      type: Object,
      required: false,
      default: () => null
    }
  },

  data () {
    return {
      content: '',
      edit: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['clean']
          ]
        }
      },
      activator: null,
      tags: this.product.tags,
      search: null
    }
  },

  computed: {
    verrors () {
      return field => {
        if (!this.product.errors) {
          return []
        }
        return this.product.errors
          .filter(obj => obj.field === field)
          .map(obj => obj.message)
          .flat()
      }
    }
  },

  mounted () {
    this.content = this.product.description
  },

  methods: {
    generateSlug () {
      if (!this.product.name) {
        return
      }

      const slugify = (string) => string.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '')
      const trim = (str, char) => str.split(char).filter(Boolean).join(char)

      this.product.slug = trim(slugify(this.product.name), '-')
    },

    filterTag (item, queryText, itemText) {
      const hasValue = val => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      )
    }
  }
}
</script>
